export const ACHIEVEMENTS_LIST = [
    { earned: false, name: 'BeginnerJourney' },
    // { earned: false, name: 'Royalty' },
    { earned: false, name: 'Fireball' },
    { earned: false, name: 'Firework' },
    { earned: false, name: 'Comet' },
    { earned: false, name: 'Overachiever' },
    { earned: false, name: 'BananaChamp' },
   
  ]